import { Carousel } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import InfiniteSlide from '~/shared/components/slider/components/infinite-slide/infinite-slide';
import type { PostType } from '~/shared/types/post-type';

import SingleItem from './components/single-item';

import '~/shared/components/slider/slider.scss';
//import 'react-responsive-carousel/lib/styles/carousel.min.css';

type GetSlidePropsType = {
  index: number;
  pageToGo: string;
  itemType?: string;
  data: PostType;
  onItemClick?: (index: number) => void;
};

const getSlide = ({ activeSlideIndex, data, itemType, getTagLink, index, pageToGo }: GetSlidePropsType) => {
  switch (itemType) {
    case 'infinite-slide':
      return (
        <InfiniteSlide
          activeSlideIndex={activeSlideIndex}
          getTagLink={getTagLink}
          key={data?._id}
          data={data}
          index={index}
          pageToGo={pageToGo}
        />
      );
    default:
      return <SingleItem key={data?._id} data={data} pageToGo={pageToGo} />;
  }
};

type SliderPropsType = {
  items: Record<string, unknown>[];
  pageToGo?: string;
  className?: string;
  itemType?: string;
  centerSlidePercentage?: number;
  centerMode?: boolean;
  centerPadding?: string;
  autoPlay?: boolean;
  infiniteLoop?: boolean;
  interval?: number;
  slidesToShow?: number;
  slidesToScroll?: number;
  activeSlideIndex?: number;
  sliderRef?: React.MutableRefObject<any>;
  setActiveSlideIndex?: (index: number) => void;
  getTagLink?: (data: any) => string;
  onItemClick?: (index: number) => void;
  onChange?: (index: number, item: ReactNode) => void;
};

const Slider = ({
  items,
  onChange,
  autoPlay = false,
  centerMode = true,
  centerPadding = '50px',
  infiniteLoop = false,
  className,
  interval = 3000,
  pageToGo,
  slidesToShow = 4,
  slidesToScroll = 1,
  activeSlideIndex,
  getTagLink,
  sliderRef,
  setActiveSlideIndex,
  itemType,
  onItemClick,
}: SliderPropsType) => {
  const slides = items?.map((data: PostType, index: number) =>
    getSlide({
      data,
      itemType,
      getTagLink,
      activeSlideIndex,
      onItemClick,
      index,
      pageToGo,
    }),
  );

  return (
    <div className={classNames('slider', className)}>
      <Carousel
        ref={(slider) => {
          if (sliderRef) {
            sliderRef.current = slider;
          }
        }}
        centerMode={centerMode}
        centerPadding={centerPadding}
        arrows
        afterChange={(event) => {
          setActiveSlideIndex?.(event);
        }}
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        autoplay={autoPlay}
        autoplaySpeed={interval}
        infinite={infiniteLoop}
        onChange={onChange}
      >
        {slides}
      </Carousel>
    </div>
  );
};

export default Slider;

